<div>
  <!-- Header -->
  <div class="commandes-header">
    <button mat-button mat-raised-button id="btn-new-order" (click)="createNewOrder()" [disabled]="lockElement">
      <mat-icon>add</mat-icon>
      {{'Nouvelle commande' | translate}}
    </button>
    <div class="small-border-arma-color">
      <div>{{'Afficher :' | translate }}</div>
      <mat-checkbox [disabled]="lockElement"
                    (change)="updateVisivilityColumn(true)"
                    [(ngModel)]="visibilityData.showCancel">
        {{'Annulé/Refusé' | translate}}
      </mat-checkbox>
      <mat-checkbox [disabled]="lockElement"
                    (change)="updateVisivilityColumn(true)"
                    [(ngModel)]="visibilityData.showWaiting">
        {{'En attente' | translate}}
      </mat-checkbox>
      <mat-checkbox [disabled]="lockElement"
                    (change)="updateVisivilityColumn(true)"
                    [(ngModel)]="visibilityData.showValidated">
        {{'Validé/Envoyé' | translate}}
      </mat-checkbox>
      <mat-checkbox [disabled]="lockElement"
                    (change)="onCheckShowAllSiteChange()"
                    [(ngModel)]="visibilityData.allowAllSite"
                     *ngIf="HTML_ShowAllSiteVisibility">
        {{'Tous les chantier' | translate}}
      </mat-checkbox>
    </div>
    <mat-form-field>
      <mat-icon matPrefix>search</mat-icon>
      <input matInput [disabled]="lockElement" (keyup)="onFilterChange()" [(ngModel)]="HTML_INPUT_FILTER" placeholder="{{'Rechercher' | translate}}">
    </mat-form-field>
  </div>

  <!-- Tab -->
  <div>
    <div class="table-content">

      <table mat-table [dataSource]="HTML_TABLE_DATASOURCE"
        matSort matSortActive="Code" matSortDirection="desc"
        style="margin: auto;"
        class="table-center-marge mat-elevation-z8 medium-border-arma-color cmat-table-font">
        <!-- # -->
        <ng-container [matColumnDef]="CST_MAT_TABLE_COLUMN_CODE">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> # </th>
          <td mat-cell *matCellDef="let element">{{asSteelList(element).Code}}</td>
        </ng-container>

        <ng-container [matColumnDef]="CST_MAT_TABLE_COLUMN_ORDER">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> {{'Contrat' | translate}} </th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="useJoiningCode; then thenJoiningCode else elseJoiningCode"></div>
            <ng-template #thenJoiningCode>{{asSteelList(element).OrderJoiningCode | onlyNumSupZero}}</ng-template>
            <ng-template #elseJoiningCode>{{asSteelList(element).RefExterne}}</ng-template>
          </td>
        </ng-container>

        <ng-container [matColumnDef]="CST_MAT_TABLE_COLUMN_CUSTOMER_REFERENCE">
          <th mat-header-cell *matHeaderCellDef> {{'Référence client' | translate}} </th>
          <td mat-cell *matCellDef="let element">{{asSteelList(element).CustomerRef}}</td>>
        </ng-container>

        <!-- Désignation -->
        <ng-container [matColumnDef]="CST_MAT_TABLE_COLUMN_DESIGNATION">
          <th style="width: 200px;" mat-header-cell *matHeaderCellDef> {{'Désignation' | translate}} </th>
          <td mat-cell *matCellDef="let element">{{asSteelList(element).Designation}}</td>
        </ng-container>

        <!-- Drawing -->
        <ng-container [matColumnDef]="CST_MAT_TABLE_COLUMN_DRAWING">
            <th style="width: 200px;" mat-header-cell *matHeaderCellDef> {{'Plan' | translate}} </th>
            <td mat-cell *matCellDef="let element">{{asSteelList(element).NumPlan}}</td>
          </ng-container>

        <!-- Site Code -->
        <ng-container [matColumnDef]="CST_MAT_TABLE_COLUMN_SITECODE">
          <th mat-header-cell *matHeaderCellDef> {{'Code chantier' | translate}} </th>
          <td mat-cell *matCellDef="let element"> {{asSteelList(element).CodeSite}} </td>
        </ng-container>

        <!-- Statuts -->
        <ng-container [matColumnDef]="CST_MAT_TABLE_COLUMN_STATUS">
          <th style="width: 100px;" mat-header-cell *matHeaderCellDef> {{'État' | translate}} </th>
          <td mat-cell *matCellDef="let element">{{asSteelList(element).Status}}</td>
        </ng-container>

        <!-- creation_date -->
        <ng-container [matColumnDef]="CST_MAT_TABLE_COLUMN_CREATION_DATE">
          <th style="width: 100px" mat-header-cell *matHeaderCellDef> {{'Date de création' | translate}} </th>
          <td mat-cell *matCellDef="let element">{{asSteelList(element).DateCreate}}</td>
        </ng-container>

        <!-- delivery date -->
        <ng-container [matColumnDef]="CST_MAT_TABLE_COLUMN_DELIVERY_DATE">
          <th style="width: 100px" mat-header-cell *matHeaderCellDef> {{'Date de livraison' | translate}} </th>
          <td mat-cell *matCellDef="let element">{{HTML_CONVEERT_DELPHI_DATE(asSteelList(element).DateDelivery)}}</td>
        </ng-container>

        <ng-container [matColumnDef]="CST_MAT_TABLE_COLUMN_ACTION">
          <th style="text-align: center;" mat-header-cell *matHeaderCellDef> {{'Action' | translate}} </th>
          <td mat-cell *matCellDef="let element">
            <div class="order_list_button">
              <button mat-raised-button [disabled]="lockElement" (click)="editCommande(element)">
                <mat-icon *ngIf="element.CanEdit != 0">edit</mat-icon>
                {{HTML_getTxtEditConsult(element) | translate}}
              </button>
              <button mat-raised-button color="accent" [disabled]="lockElement || element.CanEdit == 0" (click)="sendOrder(element)">
                <mat-icon>send</mat-icon>
                {{'Envoyer' | translate}}
              </button>
              <button mat-raised-button color="warn" [disabled]="lockElement || element.CanEdit == 0" (click)="cancelCommande(element)">
                <mat-icon>cancel</mat-icon>
                {{'Annuler' | translate}}
              </button>
            </div>
          </td>
        </ng-container>

        <ng-container [matColumnDef]="CST_MAT_TABLE_COLUMN_MORE">
          <th style="text-align: center;" mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <button mat-button [matMenuTriggerFor]="menu" [matMenuTriggerData]="{data: element}">
              <mat-icon>more_vert</mat-icon>
              {{'Plus' | translate}}
            </button>
          </td>
        </ng-container>

        <tr mat-header-row class="armaor-background-color tr-header" *matHeaderRowDef="HTML_TABLE_HEADER_COL; sticky: true"></tr>
        <tr mat-row
          *matRowDef="let row; columns: HTML_TABLE_HEADER_COL;"
          [ngClass]="getCssClassSteelList(row)"
          (dblclick)="editCommande(row)"></tr>
      </table>

      <mat-progress-bar style="margin: 1% 0;" *ngIf="lockElement" mode="indeterminate"></mat-progress-bar>

    </div>
  </div>
</div>

<!-- menu more pour liste d'aciers -->
<mat-menu #menu="matMenu">
  <ng-template matMenuContent let-data="data">
    <button mat-menu-item [disabled]="true" (click)="importOnCommand(data)">
      <mat-icon>file_upload</mat-icon>
      {{'Importer depuis un fichier' | translate}}
    </button>

    <button mat-menu-item [disabled]="lockElement" (click)="duplicateOrder(data)">
      <mat-icon>file_copy</mat-icon>
      {{'Dupliquer'|translate}}
    </button>
    <button mat-menu-item [disabled]="lockElement" (click)="onSeeNoteClick(data)">
      <mat-icon>note</mat-icon>
      {{'Voir les notes'|translate}}
    </button>
  </ng-template>
</mat-menu>
